import { BarChart3, Download, Link2, MousePointerClick } from 'lucide-react'
import OpenClawLandingPage from '../components/openclaw/OpenClawLandingPage'
import AdBilibiliDownloadButtons from '../components/openclaw/AdBilibiliDownloadButtons'

function OpenClawAdBilibiliDisplay() {
  return (
    <OpenClawLandingPage
      theme="rose"
      productName="OpenClaw"
      showFriendLinks={false}
      seo={{
        title: 'OpenClaw 下载',
        description: 'OpenClaw 下载页，提供适用于不同系统版本的安装包下载入口。',
        keywords: 'OpenClaw下载, OpenClaw安装包, 官方下载'
      }}
      hero={{
        eyebrow: 'OpenClaw 下载',
        title: 'OpenClaw 下载',
        subtitle: '下载并开始使用 OpenClaw',
        description:
          '本页面提供 OpenClaw 安装包下载入口，点击下方按钮即可开始下载。\n下载安装完成后，即可按客户端正常流程启动并登录使用。',
        tags: ['官方下载', '安装包下载', 'Windows版本', '登录使用'],
        guideTitle: '下载、安装、登录即可开始使用',
        guideDescription: '点击下载按钮获取安装包，完成安装后使用客户端正常登录即可。',
        guideBullets: [
          '点击下方按钮下载 Windows 安装包。',
          '安装完成后打开客户端并完成登录。',
          '如遇重复下载或重新安装，不影响正常使用。'
        ]
      }}
      screenshotCaption="该页面以官方下载安装体验为主，同时兼顾后续安装与登录流程。"
      highlights={[
        {
          icon: MousePointerClick,
          title: '官方入口清晰',
          description: '页面提供直接、清晰的下载入口，帮助用户快速获取安装包。'
        },
        {
          icon: Download,
          title: 'Windows 版本下载',
          description: '一键下载 Windows 版本安装包，点击即可开始。'
        },
        {
          icon: BarChart3,
          title: '安装后即可使用',
          description: '下载安装完成后，用户可以直接进入客户端并按正常流程登录使用。'
        }
      ]}
      steps={[
        {
          title: '进入官方下载页',
          description: '用户通过 B站广告链接进入本页面后，可直接点击下载按钮。'
        },
        {
          title: '用户点击下载',
          description: '点击下载按钮即可开始下载安装包，流程简洁直接。'
        },
        {
          title: '按步骤完成安装',
          description: '下载完成后按系统提示安装客户端，首次打开后即可进入登录流程。'
        },
        {
          title: '登录后开始使用',
          description: '登录成功后即可开始使用 OpenClaw，不需要额外操作。'
        }
      ]}
      sections={[
        {
          title: '下载安装流程简单直接',
          description:
            '本页面按照常见官方下载页的方式组织内容，用户只需点击下载按钮获取安装包，再完成登录即可正常使用。'
          ,
          items: [
            'Windows 版本入口清晰。',
            '下载、安装、登录三个步骤衔接顺畅。',
            '重复下载或重新安装不会影响正常使用。',
            '页面信息简洁，便于快速完成下载。'
          ]
        },
        {
          title: '下载信息清晰易懂',
          description: '页面只保留用户下载、安装和登录所需的信息，阅读路径更直接，使用起来更顺手。',
          items: [
            '页面风格统一，下载安装入口更直观。',
            '一个按钮即可开始下载。',
            '安装完成后可直接进入客户端登录。',
            '适合首次下载和重复下载安装使用。'
          ]
        }
      ]}
      closing={{
        title: '点击下方按钮开始下载',
        description: '点击下载按钮获取 OpenClaw 安装包，完成安装后即可登录并开始使用。',
        footerTitle: '下载、安装、登录一步完成',
        footerDescription: '点击下方按钮下载安装包，完成安装后即可启动客户端并正常登录使用。',
        footerTags: ['OpenClaw下载', 'Windows版本', '安装体验', '客户端下载']
      }}
      downloadContent={<AdBilibiliDownloadButtons theme="rose" />}
    />
  )
}

export default OpenClawAdBilibiliDisplay
